module.exports = __webpack_public_path__ + "img/Pyxis.57bb5f5a.png";